import LoadingIcon from "./LoadingIcon";
/** @deprecated */
export default LoadingIcon;
export { LoadingIcon } from "./LoadingIcon";
